import { jsxs as o, jsx as e, Fragment as C } from "react/jsx-runtime";
import { useChatbotContext as x } from "../../hooks/useChatbotContext.js";
import { useState as p, useEffect as v } from "react";
import { BotMessageAvatar as N } from "./BotMessageAvatar.js";
function Z({
  index: t,
  message: a,
  showFeedback: h
}) {
  const { chatbot: r, cn: i, formatDate: w, handleFeedback: u, isEditing: g } = x(), d = V(a.data), [l, s] = p(d);
  v(() => {
    s(d);
  }, [d]);
  const [b, y] = p(!0), [n, m] = p(!1);
  return v(() => {
    if (n) {
      const c = setTimeout(() => {
        m(!1);
      }, 2e3);
      return () => clearTimeout(c);
    }
  }, [n]), /* @__PURE__ */ o(
    "div",
    {
      className: i(
        "flex flex-row items-center gap-2.5 text-[14.5px] leading-[1.21] @notMobile:text-[13px] min-[409px]:max-[409px]:text-[13px]",
        { "mb-[5px]": r == null ? void 0 : r.avatarUrl, "mb-2.5": !(r != null && r.avatarUrl) }
      ),
      children: [
        /* @__PURE__ */ e(N, {}),
        /* @__PURE__ */ e(
          "p",
          {
            className: "line-clamp-2 grow font-medium text-foreground",
            "data-testid": "chatbot-name",
            children: r == null ? void 0 : r.publicName
          }
        ),
        /* @__PURE__ */ o("span", { className: "inline-flex items-center gap-x-0.5", children: [
          l !== -1 ? /* @__PURE__ */ o(
            f,
            {
              "aria-label": "Good response",
              "data-tooltip": "Good response",
              disabled: g || !!l,
              className: i({ hidden: !h }),
              onClick: () => {
                s(1), u(a, 1);
              },
              children: [
                /* @__PURE__ */ e(
                  "svg",
                  {
                    xmlns: "http://www.w3.org/2000/svg",
                    fill: "none",
                    viewBox: "0 0 24 24",
                    height: 16,
                    width: 16,
                    name: "ratingThumbsUp",
                    children: /* @__PURE__ */ e(
                      "path",
                      {
                        fill: "currentColor",
                        d: "M19 7h-4V4a2 2 0 0 0-2-2h-1.43L6 8.64V16h2V9.36L12.5 4h.5v5h6a1 1 0 0 1 1 1v2.68L15.53 18H6v2h10.47L22 13.4V10a3 3 0 0 0-3-3ZM2 20h2V9H2v11Z"
                      }
                    )
                  }
                ),
                /* @__PURE__ */ e("span", { className: "sr-only", children: "Positive rating" })
              ]
            }
          ) : null,
          l !== 1 ? /* @__PURE__ */ o(
            f,
            {
              "aria-label": "Bad response",
              "data-tooltip": "Bad response",
              disabled: g || !!l,
              className: i({ hidden: !h }),
              onClick: () => {
                s(-1), u(a, -1);
              },
              children: [
                /* @__PURE__ */ e(
                  "svg",
                  {
                    xmlns: "http://www.w3.org/2000/svg",
                    fill: "none",
                    viewBox: "0 0 24 24",
                    height: 16,
                    width: 16,
                    name: "ratingThumbsDown",
                    children: /* @__PURE__ */ e(
                      "path",
                      {
                        fill: "currentColor",
                        d: "M2 10.6V14a3 3 0 0 0 3 3h4v3a2 2 0 0 0 2 2h1.43L18 15.36V8h-2v6.64L11.5 20H11v-5H5a1 1 0 0 1-1-1v-2.68L8.47 6H18V4H7.53L2 10.6ZM20 4v11h2V4h-2Z"
                      }
                    )
                  }
                ),
                /* @__PURE__ */ e("span", { className: "sr-only", children: "Negative rating" })
              ]
            }
          ) : null,
          b ? /* @__PURE__ */ e(
            f,
            {
              "aria-live": "polite",
              "aria-label": n ? "Copied!" : "Copy",
              "data-tooltip": n ? void 0 : "Copy",
              disabled: n,
              className: i({ hidden: t < 1 }),
              onClick: () => {
                try {
                  navigator.clipboard.writeText(a.content), m(!0);
                } catch (c) {
                  console.warn("Unable to copy to clipboard", c), y(!1);
                }
              },
              children: /* @__PURE__ */ e(
                "svg",
                {
                  xmlns: "http://www.w3.org/2000/svg",
                  "aria-hidden": "true",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  height: 16,
                  width: 16,
                  children: n ? /* @__PURE__ */ e(
                    "path",
                    {
                      "data-testid": "copied-icon",
                      fill: "currentColor",
                      d: "m18.51 6.82-8.26 8.27-4.43-4.43-1.41 1.41 5.84 5.84 9.68-9.67-1.42-1.42Z"
                    }
                  ) : /* @__PURE__ */ o(C, { children: [
                    /* @__PURE__ */ e(
                      "path",
                      {
                        "data-testid": "copy-icon",
                        fill: "currentColor",
                        d: "M2 22h16V6H2v16ZM4 8h12v12H4V8Z"
                      }
                    ),
                    /* @__PURE__ */ e("path", { fill: "currentColor", d: "M6 2v2h14v14h2V2H6Z" })
                  ] })
                }
              )
            }
          ) : null,
          a.createdAt ? /* @__PURE__ */ e(
            "time",
            {
              dateTime: a.createdAt.toISOString(),
              className: "text-foreground/70",
              children: w(a.createdAt, "h:mmaaa")
            }
          ) : null
        ] })
      ]
    }
  );
}
function f(t) {
  const { cn: a } = x();
  return /* @__PURE__ */ e(
    "button",
    {
      ...t,
      type: "button",
      className: a(
        "relative rounded-small border-border bg-background text-foreground/70 ring ring-transparent ring-offset-2 ring-offset-background transition after:pointer-events-none after:absolute after:-top-2 after:z-10 after:-translate-x-1/2 after:-translate-y-full after:whitespace-nowrap after:rounded-full after:bg-card-foreground after:px-3 after:text-base after:font-semibold after:leading-7 after:text-card after:opacity-0 after:transition-opacity after:delay-200 after:duration-300 after:ease-in-out after:content-[attr(data-tooltip)] hover:bg-accent hover:text-accent-foreground hover:after:opacity-100 focus-visible:ring-ring disabled:hover:scale-100 [&_svg]:m-1 [&_svg]:size-3",
        t.className
      )
    }
  );
}
function V(t) {
  return typeof t == "object" && t != null && "rating" in t && typeof t.rating == "number" ? t.rating : 0;
}
export {
  Z as BotMessageHeader
};
